import React, { useState, useRef, useEffect } from "react";
import { createPortal } from "react-dom";
import BugReportModal from "./BugReportModal";
import FeatureRequestModal from "./FeatureRequestModal";

function HelpMenu({ isAdmin, onNavigateToSubmissions }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [bugModalOpen, setBugModalOpen] = useState(false);
  const [featureModalOpen, setFeatureModalOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <>
      <div className="help-menu-wrapper" ref={menuRef}>
        <button
          className="nav-item help"
          title="Help"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span className="icon svg-icon" style={{"--icon-url": "url(/images/Icons/SVG/Messages_Icon.svg)"}} />
          <span className="label">Help</span>
        </button>

        {menuOpen && (
          <div className="help-popup-menu">
            <button
              className="help-popup-item"
              onClick={() => {
                setMenuOpen(false);
                setBugModalOpen(true);
              }}
            >
              🐛 Report a Bug
            </button>
            <button
              className="help-popup-item"
              onClick={() => {
                setMenuOpen(false);
                setFeatureModalOpen(true);
              }}
            >
              💡 Request a Feature
            </button>
            {isAdmin && (
              <>
                <div className="help-popup-divider" />
                <button
                  className="help-popup-item admin"
                  onClick={() => {
                    setMenuOpen(false);
                    onNavigateToSubmissions();
                  }}
                >
                  📋 View Submissions
                </button>
              </>
            )}
          </div>
        )}
      </div>

      {/* On the page, not in the sidebar: its stacking (z-index 100) would cap the dialogs under pinned page bars. */}
      {bugModalOpen && createPortal(<BugReportModal onClose={() => setBugModalOpen(false)} />, document.body)}
      {featureModalOpen && createPortal(<FeatureRequestModal onClose={() => setFeatureModalOpen(false)} />, document.body)}
    </>
  );
}

export default HelpMenu;
